import React, {FC, Fragment} from 'react';
import {Stickers} from "./StickersList";
import downIcon from "../../assets/images/moveLayerDown.svg";
import {t} from "i18next";
import Tooltip from "../Tooltip/Tooltip";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import url from "../../utils/UrlHelper";
import {Link} from "react-router-dom";
import {setIsOrderFormModalOpen} from "../../redux/orders/reducer";
import b64toBlob from "../../utils/FileHelper";


interface StickersItemProps {
    item: Stickers,
    stickerList: Stickers[],
    setStickerList: (list: Stickers[]) => void,
    counter: any
}

const StickerItem: FC<StickersItemProps> = ({ item, counter}) => {
    const dispatch = useAppDispatch();
    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    function handleClickDownload(file: string, skus: string){
        const blob = b64toBlob(file, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.setAttribute('href', blobUrl);
        link.setAttribute('download', skus + '.pdf');
        link.click();
        setTimeout(() => {
            document.body.removeChild(link)
        }, 500)
    }

    const closeModalHandler = () => {
        dispatch(setIsOrderFormModalOpen(false))
    }

    return (
        <tr className="border-b border-gray-200 py-2 ">
            <td>
                <div className="text-gray-400">
                    {counter + 1}
                </div>
            </td>
            <td className="pr-[20px]">
                <div className="flex items-center">
                    { item.skus.map((a: string, index: number, arr: any) =>
                        <Fragment key={index}>
                            <Link target="_blank" className="font-medium text-indigo-500 hover:text-indigo-600" onClick={closeModalHandler} to={url(`/:sellerId/pim/edit/${item.productIds}`, sellerId)}>{ a.length > 0
                                ?
                                a
                                :
                                <div className="m-4">
                                    <div className="flex items-center space-x-2">
                                        {/* Start */}
                                        <Tooltip title={t('Not SKUS', {ns: "messages"}) + ' (' + t('ID LK', {ns: "messages"}) + (item.productIds[index].length > 0 ? item.productIds[index] : '-')  + ')'}>
                                            <svg className="w-4 h-4 fill-current text-gray-400" viewBox="0 0 16 16">
                                                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
                                            </svg>
                                        </Tooltip>
                                        {/* End */}
                                    </div>
                                </div>

                            }</Link>
                            {arr.length - 1 !== index
                                ?
                                <span className="block w-px h-4 bg-gray-200 mx-2" aria-hidden="true"></span>
                                :
                                ''
                            }
                        </Fragment>
                    )}
                </div>
            </td>
            <td className="py-3 whitespace-nowrap">
                <div className="flex items-center justify-end">
                    {item.file ?
                        <button className='flex items-center text-gray-400 hover:text-gray-500 rounded-full mr-2' onClick={() => handleClickDownload(item.file, item.skus)}>
                            <span className="sr-only">Скачать</span>
                            { item.skus.map((a: string, index: number, arr: any) =>
                                <>
                                    <span>
                                        { a.length > 0
                                            ?
                                            a
                                            :
                                            ', '
                                        }
                                    </span>
                                    {arr.length - 1 !== index
                                        ?
                                        <span>,&nbsp;</span>
                                        :
                                        ''
                                    }
                                </>


                            )}
                            <img src={downIcon} className="ml-2" />
                        </button>
                        :
                        ''
                    }
                </div>
            </td>
        </tr>
    );
};

export default StickerItem;